import React, { useEffect, useState } from "react";
import Link from "next/link";
import * as News from "./Esg-guide-news-styles";
import { useRouter } from "next/router";

const NewsList = ({ show, newsList }) => {
  const router = useRouter();

  const moveToDetail = (id) => {
    router.push(`/esg-guide/post/${id}`);
  };
  return (
    <>
      {newsList?.map((item, i) => (
        <News.ArticleBox
          className="wow fadeIn animated hover-up"
          key={i}
          onClick={() => moveToDetail(item.id)}
        >
          {item.thumbnail && (
            <div className="img_wrapper">
              <img src={`${item.thumbnail}`} alt={`${item.title}`} />
            </div>
          )}
          <Link href={`/esg-guide/post/${item.id}`}>
            <div className="content_wrapper">
              <h5 className="post_title">{item.title}</h5>
              <p className="post_desc">{item.sub_title}</p>
              <p className="post_summary">{item.summary}</p>
              <span className="post_date">
                <i className="fi-rs-clock"></i> {item.wdate}
              </span>
            </div>
          </Link>
        </News.ArticleBox>
      ))}
    </>
  );
};

export default NewsList;
